import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {isStringArray} from '@Components/ai-chat-window/lib/stream-component-prop-guards';
import type {DraftDiscardedNoteProps} from './draft-discarded-note.types';
import {DraftDiscardedNote} from './draft-discarded-note';

const parseDraftDiscardedNoteProps = (props: Record<string, unknown>): DraftDiscardedNoteProps | null => {
  return isStringArray(props.discardedDraftIds) ? {discardedDraftIds: props.discardedDraftIds} : null;
};

export const draftDiscardedNoteRegistration = defineStreamComponentRegistration(StreamComponentType.DRAFT_DISCARDED, DraftDiscardedNote, parseDraftDiscardedNoteProps);
